import { Injectable } from '@angular/core';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Injectable()
export class DateMomentParserFormatter extends NgbDateParserFormatter {
  constructor() {
    super();
  }

  private momentFormat: string;

  public set formatString(value: string){
    this.momentFormat = value;
  }

  format(date: NgbDateStruct): string {
    if (date === null) {
      return '';
    }
    const d = moment({
      year: date.year,
      month: date.month - 1,
      date: date.day
    });
    return d.isValid() ? d.format(this.momentFormat) : '';
  }

  parse(value: string): NgbDateStruct {
    if (!value || this.isWrongFormat(value)) {
      return null;
    }
    const d = moment(value, [this.momentFormat, 'DD-MM-YYYY']);
    return d.isValid() ? {
      year: d.year(),
      month: d.month() + 1,
      day: d.date()
    } : null;
  }

  /**
   * Check if the input value consist only of numbers or contains '/'
   *
   * @returns true if the numbers only or contains '/'
   */
  isWrongFormat(value: string): boolean {
    const reg = /^[\d ]*$/;
    return !!((value.indexOf('/') !== -1) || value.match(reg));
  }
}
